(() => {
  if (window.lvAhorroActivo) return;
  window.lvAhorroActivo = true;

  const actualSelector =
    '[data-essential-cart-element="line-item-discounted-price"]';
  const anteriorSelector =
    '[data-essential-cart-element="line-item-regular-price"]';

  const formato = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR'
  });

  function centimos(texto) {
    const limpio = texto
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '');

    if (!/^\d+(?:\.\d{3})*,\d{2}$/.test(limpio)) {
      return null;
    }

    return Math.round(
      Number(limpio.replace(/\./g, '').replace(',', '.')) * 100
    );
  }

  function actualizar() {
    document.querySelectorAll(actualSelector).forEach((actual) => {
      let bloque = actual.parentElement;
      let anterior = null;

      /* Busca el contenedor más cercano con una sola pareja de precios. */
      while (bloque && bloque.id !== 'cart-drawer') {
        const actuales = bloque.querySelectorAll(actualSelector);
        const anteriores = bloque.querySelectorAll(anteriorSelector);

        if (actuales.length > 1 || anteriores.length > 1) break;

        if (actuales.length === 1 && anteriores.length === 1) {
          anterior = anteriores[0];
          break;
        }

        bloque = bloque.parentElement;
      }

      let etiqueta = actual.querySelector('[data-lv-ahorro]');
      const precioActual = centimos(
        Array.from(actual.childNodes)
          .filter((nodo) =>
            !(nodo.nodeType === 1 && nodo.hasAttribute('data-lv-ahorro'))
          )
          .map((nodo) => nodo.textContent)
          .join('')
      );
      const precioAnterior = anterior
        ? centimos(anterior.textContent)
        : null;

      if (
        precioActual === null ||
        precioAnterior === null ||
        precioAnterior <= precioActual
      ) {
        if (etiqueta) etiqueta.remove();
        return;
      }

      const texto =
        'Ahorras ' + formato.format((precioAnterior - precioActual) / 100);

      if (!etiqueta) {
        etiqueta = document.createElement('span');
        etiqueta.setAttribute('data-lv-ahorro', '');
        etiqueta.style.cssText =
          'display:block;color:#00875a;font-size:12px;' +
          'font-weight:600;line-height:1.4;margin-top:4px;';
        actual.appendChild(etiqueta);
      }

      if (etiqueta.textContent !== texto) {
        etiqueta.textContent = texto;
      }
    });
  }

  let pendiente = false;

  new MutationObserver(() => {
    if (pendiente) return;
    pendiente = true;

    requestAnimationFrame(() => {
      pendiente = false;
      actualizar();
    });
  }).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });

  actualizar();
})();
